import * as v from "valibot";

export const searchParamsSchema = v.object({
  email: v.pipe(v.string(), v.email()),
  code: v.pipe(v.number()),
});
